import { BookingQuery, HotelSavedCardStatus } from 'generated/graphql';

type Props = Pick<
  BookingQuery['booking'],
  'travelerPaymentMethod' | 'guestPaymentMethods'
>;

const statusLabels: Record<HotelSavedCardStatus, string> = {
  AVAILABLE: 'Selected',
  EXPIRED: 'Selected card expired',
  REMOVED: 'Selected card unavailable',
  UNKNOWN: 'Selected card status unavailable',
};

export function PaymentMethodDetails({
  travelerPaymentMethod,
  guestPaymentMethods,
}: Props) {
  const methods = guestPaymentMethods?.length
    ? guestPaymentMethods
    : travelerPaymentMethod
      ? [travelerPaymentMethod]
      : [];
  return (
    <section
      aria-label="Payment methods for this booking"
      className="flex flex-col gap-2 text-sm text-text sm:flex-row sm:justify-between sm:gap-4"
    >
      <p>Payment method{methods.length > 1 ? 's' : ''}:</p>
      <div className="min-w-0 space-y-3 sm:text-right">
        {methods.length ? (
          methods.map((method, index) => (
            <div key={index}>
              {'guestName' in method && (
                <p className="font-medium">{method.guestName}</p>
              )}
              <p>
                {method.brand} ending in {method.last4}
              </p>
              <p className="text-xs text-text-secondary">
                Expires {String(method.expiryMonth).padStart(2, '0')}/
                {method.expiryYear} · {statusLabels[method.status]}
              </p>
            </div>
          ))
        ) : (
          <p className="text-text-secondary">Not collected for this booking</p>
        )}
      </div>
    </section>
  );
}
